import axios from "axios";

export class PartImagesApi {
    public static client() {
        const baseURL = PartImagesApi.getBaseURL();

        const client = axios.create({
            baseURL,
        });

        client.defaults.headers.Accept = "application/json";
        client.defaults.withCredentials = false;

        return client;
    }

    public static getBaseURL() {
        let baseURL = window.appGlobals.PART_IMAGES_API_URL || "";

        if (baseURL.endsWith("/")) {
            baseURL = baseURL.substr(0, baseURL.length - 1);
        }

        return baseURL;
    }
}
